module.exports = __webpack_public_path__ + "media/images/badges/yogasix/inactive/Y6Warrior2022_Badges_1750_Inactive@1x-873e8baf4bc8d4f1d3743c7ee6d3899d.png";